import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Button, Space } from "antd";
/**
 * 通用模态框容器组件
 * 支持 footer 左侧按钮和右侧两个按钮，支持自定义宽高和内容内边距
 */
const ContainerModal = ({ title, visible, width = 800, height = 600, children, footerLeftButtons = [], footerRightButtons = [], contentPadding = 16, onCancel, onTitleClick, modalProps = {}, }) => {
    // 渲染左侧按钮
    const renderLeftButtons = () => {
        if (!footerLeftButtons || footerLeftButtons.length === 0) {
            return null;
        }
        // 如果是 React 节点数组，直接渲染
        if (Array.isArray(footerLeftButtons) &&
            footerLeftButtons.length > 0 &&
            React.isValidElement(footerLeftButtons[0])) {
            return _jsx(Space, { children: footerLeftButtons });
        }
        // 如果是按钮配置数组
        return (_jsx(Space, { children: footerLeftButtons.map((button) => {
                if (button.hidden)
                    return null;
                const buttonType = button.type === "danger" ? "default" : button.type;
                return (_jsx(Button, { type: buttonType, danger: button.type === "danger", icon: button.icon, loading: button.loading, disabled: button.disabled, onClick: button.onClick, children: button.text }, button.key));
            }) }));
    };
    // 渲染右侧按钮（最多两个）
    const renderRightButtons = () => {
        if (!footerRightButtons || footerRightButtons.length === 0) {
            return null;
        }
        // 限制最多两个按钮
        const buttonsToRender = footerRightButtons.slice(0, 2);
        // 如果是 React 节点数组，直接渲染
        if (Array.isArray(buttonsToRender) &&
            buttonsToRender.length > 0 &&
            React.isValidElement(buttonsToRender[0])) {
            return _jsx(Space, { children: buttonsToRender });
        }
        // 如果是按钮配置数组
        return (_jsx(Space, { children: buttonsToRender.map((button) => {
                if (button.hidden)
                    return null;
                const buttonType = button.type === "danger" ? "default" : button.type;
                return (_jsx(Button, { type: buttonType, danger: button.type === "danger", icon: button.icon, loading: button.loading, disabled: button.disabled, onClick: button.onClick, children: button.text }, button.key));
            }) }));
    };
    // 构建 Footer
    const renderFooter = () => {
        const leftButtons = renderLeftButtons();
        const rightButtons = renderRightButtons();
        // 如果没有任何按钮，返回 null（隐藏 footer）
        if (!leftButtons && !rightButtons) {
            return null;
        }
        return (_jsxs("div", { style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }, children: [_jsx("div", { children: leftButtons }), _jsx("div", { children: rightButtons })] }));
    };
    // 构建 Modal body 样式
    // 计算 body 高度：总高度减去 header（约 55px）和 footer（约 53px）
    const bodyHeight = typeof height === "number" ? Math.max(height - 55 - 53, 0) : undefined;
    const toCssUnit = (v) => typeof v === "number" ? `${v}px` : v;
    const resolvePadding = (p) => {
        if (p === undefined)
            return undefined;
        if (typeof p === "number" || typeof p === "string") {
            return toCssUnit(p);
        }
        const t = toCssUnit(p.top ?? p.vertical);
        const r = toCssUnit(p.right ?? p.horizontal);
        const b = toCssUnit(p.bottom ?? p.vertical);
        const l = toCssUnit(p.left ?? p.horizontal);
        return [t ?? "0", r ?? "0", b ?? "0", l ?? "0"].join(" ");
    };
    const bodyStyle = {
        padding: resolvePadding(contentPadding ?? 16),
        height: bodyHeight === undefined ? undefined : `${bodyHeight}px`,
        overflow: "auto",
        ...modalProps.styles?.body,
    };
    // 处理标题点击事件
    const renderTitle = () => {
        if (title && onTitleClick) {
            const handleKeyDown = (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onTitleClick();
                }
            };
            return (_jsx("button", { type: "button", onClick: onTitleClick, onKeyDown: handleKeyDown, style: {
                    cursor: "pointer",
                    userSelect: "none",
                    background: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    font: "inherit",
                    color: "inherit",
                    textAlign: "inherit",
                    width: "100%",
                }, children: title }));
        }
        return title;
    };
    return (_jsx(Modal, { title: renderTitle(), open: visible, width: width, onCancel: onCancel, footer: renderFooter(), styles: {
            ...modalProps.styles,
            body: bodyStyle,
            header: {
                ...modalProps.styles?.header,
            },
            footer: {
                ...modalProps.styles?.footer,
            },
        }, style: {
            ...(typeof height === "string" ? { height } : {}),
            ...modalProps.style,
        }, ...modalProps, children: children }));
};
export default ContainerModal;
